var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.$style.discount},[_vm._v(_vm._s(_vm.discount)),_c('IconSelect',{staticClass:"ml-1",class:_vm.$style.discountIcon,attrs:{"icon":"flag"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }